import Vue from "vue";
import App from "./App.vue";
import * as firebase from "firebase";
import router from "./routes/index";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueMapbox from "vue-mapbox";
import Mapbox from "mapbox-gl";


Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueMapbox, { mapboxgl: Mapbox });
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA0drn_G-aPRVs391s2k-xSNNwNv9_ZUTs',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },

  installComponents: true
})

const configOptions = {
  apiKey: "AIzaSyB655jV7VTpE6idLx-dfftse2u9AD8cx2Y",
  authDomain: "flutter-gps-tracker.firebaseapp.com",
  databaseURL: "https://flutter-gps-tracker.firebaseio.com",
  projectId: "flutter-gps-tracker",
  storageBucket: "flutter-gps-tracker.appspot.com",
  messagingSenderId: "945654686872",
  appId: "1:945654686872:web:9922b7999b5ae479001ced"
};

firebase.initializeApp(configOptions);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");